// extracted by mini-css-extract-plugin
module.exports = {"add-result-btn":"AddResult_add-result-btn__2EATs"};